export default class Search {
	constructor(root) {
		this.root = root;
		this.summaryEl = root?.querySelector('.search-summary');
		this.searchQuery = this.summaryEl?.querySelector('.search-query');

		document.addEventListener('fwp-refresh', this.renderSummary.bind(this));
	}

	renderSummary() {
		if (this.searchQuery) {
			this.searchQuery.textContent = FWP.facets.q;
			console.log(FWP.facets.q);
		}
	}
}
